/**
 * Get the API URL based on the current environment
 * For network access, we need to use the network IP directly (Vite proxy doesn't work for network IPs)
 */
export function getApiUrl(): string {
  // Check if VITE_API_URL is explicitly set (required for production deployment)
  const envApiUrl = import.meta.env.VITE_API_URL;
  if (envApiUrl) {
    return envApiUrl.replace(/\/$/, ''); // Remove trailing slash
  }

  const hostname = window.location.hostname;
  const protocol = window.location.protocol;
  
  // If we're on localhost, use relative URL to leverage Vite proxy
  if (hostname === 'localhost' || hostname === '127.0.0.1') {
    if (import.meta.env.DEV) {
      // Use relative URL - Vite proxy will handle it
      return '';
    }
    return 'http://localhost:3001';
  }

  // Production domain (railway.app, vercel.app, etc.) without VITE_API_URL = misconfigured
  if (hostname.includes('railway.app') || hostname.includes('vercel.app') || hostname.includes('netlify.app')) {
    console.error('VITE_API_URL is not set. Add it to your frontend environment variables (e.g. VITE_API_URL=https://your-backend.up.railway.app)');
    return ''; // Will fail with clear network error
  }

  // Local network IP - backend is on same IP, port 3001
  return `${protocol}//${hostname}:3001`;
}

export const API_URL = getApiUrl();

